// extracted by mini-css-extract-plugin
export default {"parent":"styles_parent__DiwbU"};